/**
 * Hardcoded Season 1 Team Players Data
 *
 * This file contains the complete roster data for all Season 1 teams.
 * Similar to season1BracketData.ts, this ensures player data displays correctly
 * even if the PowerStats API is unavailable or returns inconsistent data.
 *
 * Data fetched from PowerStats API on 2025-01-17
 */

export interface Season1Player {
  steamID: string;
  playerName: string;
  name: string | null;
  role: string | null;
  age: number | null;
}

export interface Season1TeamRoster {
  teamId: string;
  teamName: string;
  seed: string;
  division: string;
  players: Season1Player[];
}

export const SEASON_1_TEAM_ROSTERS: Season1TeamRoster[] = [
  // Division 1 Teams
  {
    teamId: '420',
    teamName: 'Powerstats',
    seed: '1',
    division: '1',
    players: [
      {
        steamID: '76561198059636829',
        playerName: 'Zlause',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198183348569',
        playerName: 'LoweN-',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198278140719',
        playerName: 'Bloody',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198445123150',
        playerName: 'Bukki',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561199033760198',
        playerName: 'Minken',
        name: null,
        role: null,
        age: null,
      },
    ],
  },
  // Duplicate entry with backend GUID format
  {
    teamId: '00000000-0000-0000-0000-000000000420',
    teamName: 'Powerstats',
    seed: '1',
    division: '1',
    players: [
      {
        steamID: '76561198059636829',
        playerName: 'Zlause',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198183348569',
        playerName: 'LoweN-',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198278140719',
        playerName: 'Bloody',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198445123150',
        playerName: 'Bukki',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561199033760198',
        playerName: 'Minken',
        name: null,
        role: null,
        age: null,
      },
    ],
  },
  {
    teamId: '321a4f92-b4a9-45a2-baa5-7b3ce91941c4',
    teamName: 'Prestige Esport Cheetah',
    seed: '3',
    division: '1',
    players: [
      {
        steamID: '76561198059322915',
        playerName: 'deep',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198203780216',
        playerName: 'Hauge',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198842197798',
        playerName: 'Alexzi',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561199066108638',
        playerName: 'bxrk',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561199187413982',
        playerName: 'Staby',
        name: null,
        role: null,
        age: null,
      },
    ],
  },
  {
    teamId: '5177806c-d4e8-428f-b2b3-39f4cd4032d2',
    teamName: 'Rising Stars Selected',
    seed: '5',
    division: '1',
    players: [
      {
        steamID: '76561198157504520',
        playerName: 'LuKZeN',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198261133739',
        playerName: 'STJERNE',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198304901397',
        playerName: 'givenchy',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198881189893',
        playerName: 'BaLsNeR',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198984376510',
        playerName: 'Kaito',
        name: null,
        role: null,
        age: null,
      },
    ],
  },
  {
    teamId: 'bebb3efb-331f-4532-9d31-44c7aea43fc5',
    teamName: 'AMO Esport',
    seed: '7',
    division: '1',
    players: [
      {
        steamID: '76561197981010839',
        playerName: 'z1nzy',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561197998469938',
        playerName: 'knuM',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198301442273',
        playerName: 'luzjepo',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198371339090',
        playerName: 'Ryuga',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198845508560',
        playerName: 'r0zquizt',
        name: null,
        role: null,
        age: null,
      },
    ],
  },
  // Division 2 Teams
  {
    teamId: '0a2f0f5d-de60-4972-ba30-d083ad36dd6e',
    teamName: 'Hedensted X SERA Talent',
    seed: '2',
    division: '2',
    players: [
      {
        steamID: '76561198054946724',
        playerName: 'Ekke',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198124136504',
        playerName: 'Troski',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198138532620',
        playerName: 'Ep1sk',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198361899075',
        playerName: 'BqreBedre',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198447521195',
        playerName: 'Patchi',
        name: null,
        role: null,
        age: null,
      },
    ],
  },
  {
    teamId: '69a5544e-c6c8-41fe-b72f-28f44e9cd697',
    teamName: 'Avanti NXT',
    seed: '4',
    division: '2',
    players: [
      {
        steamID: '76561198005496143',
        playerName: 'k0bra',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198141477673',
        playerName: 'schraam',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198163517386',
        playerName: 'Brandvarm',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198313091647',
        playerName: 'Patte',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198365854684',
        playerName: 'b1zjr',
        name: null,
        role: null,
        age: null,
      },
    ],
  },
  {
    teamId: '69',
    teamName: 'Unsigned Criminals',
    seed: '6',
    division: '2',
    players: [
      {
        steamID: '76561198160006089',
        playerName: 'D1DRIK',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198388382195',
        playerName: 'Flaxii',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198397764409',
        playerName: 'FlankSteak',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198401642558',
        playerName: 'Lloyd',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198981175481',
        playerName: 'Trallen',
        name: null,
        role: null,
        age: null,
      },
    ],
  },
  // Duplicate entry with backend GUID format
  {
    teamId: '00000000-0000-0000-0000-000000000069',
    teamName: 'Unsigned Criminals',
    seed: '6',
    division: '2',
    players: [
      {
        steamID: '76561198160006089',
        playerName: 'D1DRIK',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198388382195',
        playerName: 'Flaxii',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198397764409',
        playerName: 'FlankSteak',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198401642558',
        playerName: 'Lloyd',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198981175481',
        playerName: 'Trallen',
        name: null,
        role: null,
        age: null,
      },
    ],
  },
  {
    teamId: 'a027c95d-2624-48c9-a8ca-758930b8942b',
    teamName: 'Avanti Academy',
    seed: '8',
    division: '2',
    players: [
      {
        steamID: '76561198219555624',
        playerName: 'Xever',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198233292524',
        playerName: 'Zit0',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198342818190',
        playerName: 'Lynch',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198345015789',
        playerName: 'MARCHER',
        name: null,
        role: null,
        age: null,
      },
      {
        steamID: '76561198830173768',
        playerName: 'J1Nz',
        name: null,
        role: null,
        age: null,
      },
    ],
  },
];

// Helper functions
export function getSeason1TeamByName(teamName: string): Season1TeamRoster | undefined {
  return SEASON_1_TEAM_ROSTERS.find(team => team.teamName === teamName);
}

export function getSeason1TeamById(teamId: string): Season1TeamRoster | undefined {
  return SEASON_1_TEAM_ROSTERS.find(team => team.teamId === teamId);
}
